namespace OSF {
  export enum AppName {
    Unsupported = 0,
    Excel = 1,
    Word = 2,
    PowerPoint = 4,
    Outlook = 8,
    ExcelWebApp = 16,
    WordWebApp = 32,
    OutlookWebApp = 64,
    Project = 128,
    AccessWebApp = 256,
    PowerpointWebApp = 512,
    ExcelIOS = 1024,
    Sway = 2048,
    WordIOS = 4096,
    PowerPointIOS = 8192,
    Access = 16384,
    Lync = 32768,
    OutlookIOS = 65536,
    OneNoteWebApp = 131072,
    OneNote = 262144,
    ExcelWinRT = 524288,
    WordWinRT = 1048576,
    PowerpointWinRT = 2097152,
    OutlookAndroid = 4194304,
    OneNoteWinRT = 8388608,
    ExcelAndroid = 8388609,
    VisioWebApp = 8388610,
    OneNoteIOS = 8388611,
    WordAndroid = 8388613,
    PowerpointAndroid = 8388614,
    Visio = 8388615,
    OneNoteAndroid = 4194305,
  }
}
